import React, { useEffect,useState } from 'react'
import { UserEarningsWrapper } from './UserEarningsModal.style'
import { message,Modal } from 'antd';
import SecuredServices from 'api/securedServices';
import {ExclamationCircleFilled} from '@ant-design/icons';


const { confirm } = Modal;
export default function UserEarningsModal({userid}) {
    
    const [earnings,setEarnings] = useState({});
    useEffect(()=>{
        // console.log(data);
        // let userid = data.userid;
        SecuredServices.getUserEarnings(userid).then((res)=>{
            console.log(res.data);
            if(res.data.status==1){
                console.log(res.data.data);
                setEarnings(res.data.data);
            }
            else{
                message.error(res.data.message);
            }
        }).catch((err)=>{
            console.log(err);
            message.error(err.message);
        })
    },[userid])

    const handleClickOnSettleEarnings = ()=>{
        confirm({
            title: 'Are you Sure you want to settle the payment for this user?',
            icon: <ExclamationCircleFilled />,
            content: <div>
              <strong style={{color:"red"}}>Note: This action can not be reversed.</strong>
            </div>,
            onOk() {
                let apidata = {
                       iq_verification : true,
                       iq_creation_without_image : true,
                       iq_creation_with_image : true,
                       program_creation : true,
                       userid : userid
                    }
                    SecuredServices.updateUserEarnings(apidata).then((res)=>{
                        if(res.data.status==1){
                            message.success(res.data.message);
                            window.location.reload();
                        }
                        else{
                            message.error(res.data.message);
                        }
                    })
            },
            okText: 'Settle Now', 
            onCancel() {
              console.log('Cancel');
            },
          });
    }
  return (
    <UserEarningsWrapper>
          <h2 className='text-center dark-blue'>Earnings</h2>
        <div className='outerTableDiv'>
            <h3 className='text-center' style={{color:"green",fontSize:"17px",fontWeight:"bold"}}>
                Total Earnings (Payment pending) : ₹{earnings.totalAmount}
            </h3>
            <div className='tableCus'>
                <div className='headings'>
                    <p>Type</p>
                    <p>Submissions (Payment pending)</p>
                    <p>Amount</p>
                </div>
                {
                    earnings?.iqCreation &&   <div className='content'>
                    <p>IQ creations with image</p>
                    <p>{earnings?.iqCreation?.count_iq_with_image}</p>
                    <p>₹{earnings?.iqCreation?.amount_for_iq_with_image}</p>
                </div>
                }
                {
                      earnings?.iqCreation &&  <div className='content'>
                      <p>IQ creations without image</p>
                      <p>{earnings?.iqCreation?.count_iq_without_image}</p>
                      <p>₹{earnings?.iqCreation?.amount_for_iq_without_image}</p>
                  </div>
                }
                {
                      earnings?.programCreation &&   <div className='content'>
                      <p>Program creations with image</p>
                      <p>{earnings?.programCreation?.count_program_with_image}</p>
                      <p>{earnings?.programCreation?.amount_for_program_with_image}</p>
                  </div>
                }
                {
                      earnings?.programCreation &&   <div className='content'>
                      <p>Program creations without image</p>
                      <p>{earnings?.programCreation?.count_program_without_image}</p>
                      <p>{earnings?.programCreation?.amount_for_program_without_image}</p>
                  </div> 
                }
                {
                    earnings?.iqVerification &&   <div className='content'>
                    <p>IQ verifications</p>
                    <p>{earnings?.iqVerification?.count}</p>
                    <p>₹{earnings?.iqVerification?.amount}</p>
                </div>
                }
               
                {/* <div className='content'>
                    <p>Program verifications</p>
                    <p>{earnings?.missionVerification?.count}</p>
                    <p>₹{earnings?.missionVerification?.amount}</p>
                </div> */}
                <div className='footer'>
                    <p>Total</p>
                    <p>{earnings?.totalCount}</p>
                    <p>₹{earnings?.totalAmount}</p>
                </div>
            </div>
        </div>

        <div className='settleEarningsDiv'>
            <bold>Note: Please settle the earnings once the payment is done.</bold>
            <button className='settleEarnings' onClick={handleClickOnSettleEarnings}>Settle Earnings</button>
        </div>
    </UserEarningsWrapper>
  )
}
